export default "__VITE_ASSET__$d1eypyx__"